import { render, staticRenderFns } from "./BasicScreen.vue?vue&type=template&id=099fdf20&scoped=true&"
import script from "./BasicScreen.vue?vue&type=script&lang=ts&"
export * from "./BasicScreen.vue?vue&type=script&lang=ts&"
import style0 from "./BasicScreen.vue?vue&type=style&index=0&id=099fdf20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099fdf20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VRow,VToolbar})
